import request from '@/utils/request'

let FastorderApi = {
  /*获取快速订单列表*/
  getFastOrder(data, errorback) {
    return request._post('/shop/order.fast_order/lists', data, errorback);
  },
  /*获取快速订单详情*/
  getFastOrderDetail(data, errorback) {
    return request._post('/shop/order.order/fastOrderDetail', data, errorback);
  },
   //获取商品列表
  getProductList(data, errorback) {
    return request._post('/shop/product.product/productList', data, errorback);
  },
  //获取商品规格
  getSpec(data, errorback) {
    return request._post('/shop/product.product/getSpec', data, errorback);
  },
  // 创建快速订单
  getCreateOrder(data, errorback) {
    return request._post('/shop/order.fast_order/createOrder', data, errorback);
  },
  // 删除订单
  delFastOrder(data, errorback) {
    return request._post('/shop/order.fast_order/delOrder', data, errorback);
  },
  // 生成跳转二维码
  getQRcode(data, errorback) {
    return request._post('/shop/order.fast_order/crerateQrcode', data, errorback);
  },
  // 快速订单多选删除
  deleteallfastshop(data, errorback) {
    return request._post('/shop/order.fastOrder/deleteall', data, errorback);
  },
  // 获取快速商品列表
  getFastShopList(data, errorback) {
    return request._post('/shop/product.productFast/index', data, errorback);
  },
  // 快速商品添加
  addFastShop(data, errorback) {
    return request._post('/shop/product.productFast/add', data, errorback);
  },
  // 快速商品编辑修改
  editFastShop(data, errorback) {
    return request._post('/shop/product.productFast/edit', data, errorback);
  },
  // 快速商品删除
  delFastShop(data, errorback) {
    return request._post('/shop/product.productFast/delete', data, errorback);
  },
  // 快速商品多选删除
  delAllFastShop(data, errorback) {
    return request._post('/shop/product.productFast/deleteall', data, errorback);
  },
  
}
export default FastorderApi;


// WEBPACK FOOTER //
// ./src/api/fastorder.js